import { Component, OnDestroy, OnInit } from '@angular/core';

import { Subscription, switchMap, tap } from 'rxjs';

import { UsersTabsEnum } from './users-tabs.enum';
import { InvitesService, LocationUserListService } from './services';
import { AuthRestaurantService } from '@tablesready/frontend-store';

@Component({
  selector: 'tablesready-location-users',
  templateUrl: './users.component.html',
  providers: [InvitesService, LocationUserListService],
})
export class LocationUsersComponent implements OnInit, OnDestroy {
  tabs = [UsersTabsEnum.users, UsersTabsEnum.invites];
  tabValues = UsersTabsEnum;
  activeTab: string;
  timezone = '';
  private readonly subscriptions = new Subscription();

  constructor(
    private readonly authRestaurantService: AuthRestaurantService,
    private readonly locationUserListService: LocationUserListService,
    private readonly invitesService: InvitesService,
  ) { }

  ngOnInit(): void {
    this.activeTab = UsersTabsEnum.users;

    const userSub = this.authRestaurantService.select()
      .pipe(tap((user) => {
        if (!user?.location) {
          return;
        }

        this.timezone = user.location.timezone;
      }))
      .subscribe();
    this.subscriptions.add(userSub);

    const locationUserDataSubscription = this.locationUserListService.load()
      .pipe(switchMap(() => this.locationUserListService.listenToChanges()))
      .subscribe();
    this.subscriptions.add(locationUserDataSubscription);

    const invitesSubscription = this.invitesService.load()
      .pipe(switchMap(() => this.invitesService.listenToChanges()))
      .subscribe();
    this.subscriptions.add(invitesSubscription);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
    this.locationUserListService.reset();
  }

  onChangeTab(tab: string): void {
    this.activeTab = tab;
  }
}
